import { addForm, viewColomn } from '../common';

export const employeeProjects = {
  api: () => '/employeeProjects',
  title: 'Projects',
  isActionTab: true,
  modalTitle: (action) => `${action} Project`,
  getColumns: () => {
    return [
      {
        title: 'Project Name',
        dataIndex: 'projectName',
        key: 'projectName',
      },
      {
        title: 'Designation',
        dataIndex: 'designation',
        key: 'designation',
        render: (text) => {
          return (text && text.name) ? text.name : '';
        }
      },
      {
        title: 'Company Name',
        dataIndex: 'companyName',
        key: 'companyName',
      },
      {
        title: 'Team Size',
        dataIndex: 'teamSize',
        key: 'teamSize',
      },
      ...viewColomn(true)
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Project Name',
        dataIndex: 'projectName',
        key: 'projectName',
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Designation',
        dataIndex: 'designation',
        key: 'designation',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Company Name',
        dataIndex: 'companyName',
        key: 'companyName',
        isRequired: false,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        type: 'textQuill',
        formClassName: 'col-12 pb-2',
      },
      {
        title: 'Team Size',
        dataIndex: 'teamSize',
        key: 'teamSize',
        type: 'number',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Project Link',
        dataIndex: 'projectLink',
        key: 'projectLink',
        type: 'text',
        formClassName: 'col-4 pb-2',
      },
      ...addForm()
    ];
  },
  combo: [
    {
      name: 'designation',
      api: '/role',
      idKey: '_id',
      nameKey: 'name',
    },
    {
      name: 'approvalFrom',
      api: '/users/CEO/list',
      idKey: '_id',
      nameKey: ['firstName', 'middelName', 'lastName'],
    }
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add Project', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
